import { iGetOptionOrdersQueryResponse } from '../interfaces/chrInterfaces';
import { iOrder } from '../interfaces/interfaces';
import { calculateOrderPrice } from '../utils/chromia/ft4/helpers';
import { cBigNumber } from './BigNumber';


export class cChromiaOrder implements iOrder {
	ordId: number;
	ordType: boolean;   // true => sell, false => buy
	optId: string;
	owner: string
	amount: cBigNumber;
	refPrice: cBigNumber;
	delta: cBigNumber;
	ordPrice: cBigNumber;
	minMaxPrice: cBigNumber;
	currentPrice: cBigNumber;

	constructor(orderResponse: iGetOptionOrdersQueryResponse, uTokenCurrency: string){
		this.ordId = orderResponse.id;
		this.ordType = orderResponse.type === 'sell';
		this.optId = orderResponse.opt_id.toString('hex');
		this.owner = orderResponse.from.toString('hex');
		this.amount = new cBigNumber(orderResponse.amount);
		this.refPrice = new cBigNumber(orderResponse.ref_price);
		this.delta = new cBigNumber(orderResponse.delta);
		this.ordPrice = new cBigNumber(orderResponse.price);
		this.minMaxPrice = new cBigNumber(orderResponse.min_max_price);

		const curPrice = calculateOrderPrice(uTokenCurrency, new cBigNumber(orderResponse.price), this.refPrice, this.delta);
		this.currentPrice = this.ordType
			? curPrice.lt(this.minMaxPrice)? this.minMaxPrice : curPrice
			: curPrice.gt(this.minMaxPrice)? this.minMaxPrice : curPrice
		;
	}
}